module.exports = __webpack_public_path__ + "static/media/ic_sharp-send.b6c3e590.svg";